import { roundToDecimalPlaces } from '@semios/app-platform-common'
import type { CurrentValuesDataInfo } from 'App/Map/PanelDetails/OverviewCharts/OverviewColumns'
import type { TIrrigationFlowRate } from 'App/Map/PanelDetails/OverviewCharts/SectionTable/types'
import { camelToKebab } from 'App/Map/PanelDetails/OverviewCharts/SectionTable/utils'
import type { TColumnContext } from 'App/Map/PanelDetails/OverviewCharts/_utils/types'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

const MILLISECONDS_IN_HOUR = 3600000

const getFlowRateForDevice = (pointFlowRates: TIrrigationFlowRate[], device: string): number => {
  if (!device) return 0

  const kebabDevice = camelToKebab(device)

  const found = pointFlowRates.find(
    ({ irrigationZone }) => typeof irrigationZone === 'string' && irrigationZone.endsWith(kebabDevice),
  )

  return found?.flowRate ? Number(found.flowRate) : 0
}

export const renderAppliedAmount = (
  record: CurrentValuesDataInfo,
  irrigationKey: string,
  { currentView, pointsFlowRates, propertyId }: TColumnContext,
) => {
  const durationHours = Number(record[irrigationKey as keyof CurrentValuesDataInfo]) / MILLISECONDS_IN_HOUR

  if (currentView?.irrigation === 'DURATION') {
    return translate.measurements.hours.valueWithUnit(Number(roundToDecimalPlaces(durationHours, 1)), 1)
  }

  if (currentView?.irrigation === 'VOLUME') {
    const flowRates =
      pointsFlowRates?.find(
        (pointFlowRate) =>
          pointFlowRate.pointName === record.pointName &&
          Number(pointFlowRate.propertyId) === Number(propertyId),
      )?.flowRates || []

    const millimetresApplied = getFlowRateForDevice(flowRates, record.device as string) * durationHours

    return unitConverter.irrigationActivity(millimetresApplied || 0).valueWithSuffix()
  }
}
